import React, { useState, Fragment } from 'react';

import { useQueryParam, StringParam } from 'use-query-params';
import { useForm, Controller } from 'react-hook-form';
import Constants from './Constants';
import './FuelRegistration.scss';
import FlatButton from 'components/UI/FlatButton/FlatButton';
import FilledTextField from 'components/UI/FilledTextField/FilledTextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import CircularProgress from '@material-ui/core/CircularProgress';
import { fuelOnboardingAxios } from './utils/api';
import * as api from './utils/api';

// Assets
import BannerHi from './images/banner-hi.svg';
import BannerEn from './images/banner-en.svg';
import Logo from './images/logo.svg';
import BharatPetroleumImage from './images/bharat-petroleum.svg';
import EssarImage from './images/essar.svg';
import IndianOil from './images/indian-oil.svg';
import HindustanPetroleumImage from './images/hindustan-petroleum.svg';
import ReliancePetroleum from './images/reliance-petroleum.svg';
import SuccessImage from './images/success.svg';

const FuelRegistration = (props) => {
  const { handleSubmit, control, errors } = useForm();

  const onSubmit = (data) => {
    setLoader(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const postData = {};
    postData.operatorName = data.operatorName;
    postData.operatorNumber = data.operatorNumber;
    const vehicleNumbers = [];
    for (const i of indexes) {
      const vehicleNumber = data['vehicleNumber_' + i];
      if (!!vehicleNumber) {
        vehicleNumbers.push(vehicleNumber);
      }
    }
    postData.vehicleNumbers = vehicleNumbers;
    submitOperatorData(postData);
    recordGAEvent('form_submit');

  };

  const [locale, setLocale] = useQueryParam('locale', StringParam);

  const [indexes, setIndexes] = useState([1, 2, 3]);
  const [counter, setCounter] = useState(4);
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState('');

  const addTruck = () => {
    setIndexes((prevIndexes) => [...prevIndexes, counter]);
    setCounter((prevCounter) => prevCounter + 1);
  };

  const submitOperatorData = (params) => {
    api
      .postNewOperator(fuelOnboardingAxios, params)
      .then((response) => {
        setLoader(false);
        if (!!response.data.errorCode) {
          setError(response.data.message);
          setSuccess(false);
          console.log('Error:', response.data.message);
        } else {
          setError('');
          setSuccess(true);
          console.log(response);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
      .catch((error) => {
        setLoader(false);
        setError(error.message);
        setSuccess(false);
        console.log('Error:', error);
      });
  };

  const recordGAEvent = eventName => {
    if (window.ga && eventName) {
      window.ga('send', {
        hitType: 'event',
        eventCategory: 'Fuel Registration Form',
        eventAction: 'submit',
        eventLabel: eventName,
      });
    }
  }

  return (
    <div className="fuel-registration-wrapper">
      {!!error && <div className="error-container">{error}</div>}
      <div className="logo">
        <img src={Logo} alt="Logo" />
      </div>
      {loader && (
        <div className="content-container">
          <div className="loading-container">
            <CircularProgress color="secondary" size={100} />
          </div>
        </div>
      )}
      {!success ? (
        <div className={loader ? 'content-container hide' : 'content-container'}>
          <div className="language-selector">
            <div className={locale !== 'hi' ? 'lang-selected' : 'lang'} onClick={() => setLocale('en')}>
              {Constants.en.LanguageName}
            </div>
            <div className={locale === 'hi' ? 'lang-selected' : 'lang'} onClick={() => setLocale('hi')}>
              {Constants.hi.LanguageName}
            </div>
          </div>

          <div className="banner-image">{<img src={locale === 'hi' ? BannerHi : BannerEn} alt="Banner" />}</div>
          <div className="intro">{Constants[locale].Intro}</div>

          <div className="form-container">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                as={<FilledTextField placeholder={Constants[locale].NamePlaceholder} />}
                control={control}
                rules={{ required: true }}
                name="operatorName"
                defaultValue=""
              />
              {errors.operatorName && (
                <FormHelperText className="we-error" error>
                  {Constants[locale].NameError}
                </FormHelperText>
              )}
              <Controller
                as={<FilledTextField />}
                control={control}
                rules={{ required: true, minLength: 10, maxLength: 10 }}
                name="operatorNumber"
                defaultValue=""
                type="number"
                placeholder={Constants[locale].PhonePlaceholder}
                startAdornment={<InputAdornment position="start">+91</InputAdornment>}
              />
              {errors.operatorNumber?.type === 'required' && (
                <FormHelperText className="we-error" error>
                  {Constants[locale].PhoneError}
                </FormHelperText>
              )}
              {errors.operatorNumber?.type === 'minLength' && (
                <FormHelperText className="we-error" error>
                  {Constants[locale].PhoneErrorMin}
                </FormHelperText>
              )}
              {errors.operatorNumber?.type === 'maxLength' && (
                <FormHelperText className="we-error" error>
                  {Constants[locale].PhoneErrorMax}
                </FormHelperText>
              )}
              {indexes.map((index) => {
                return (
                  <Fragment key={'truck_' + index}>
                    <Controller
                      as={<FilledTextField />}
                      control={control}
                      name={'vehicleNumber_' + index}
                      defaultValue=""
                      placeholder={Constants[locale].TruckPlaceholder}
                      startAdornment={
                        <InputAdornment position="start">{Constants[locale].TruckLabel + '' + index}</InputAdornment>
                      }
                      rules={index === 1 && { required: true }}
                    />
                    {index === 1 && errors.vehicleNumber_1 && (
                      <FormHelperText className="we-error" error>
                        {Constants[locale].TruckError}
                      </FormHelperText>
                    )}
                  </Fragment>
                );
              })}
              <FlatButton textcolor="#0094f6" onClick={addTruck}>
                <span className="plus-icon"> + </span>
                {Constants[locale].AddMoreTrucks}
              </FlatButton>

              <FlatButton color="secondary" onClick={handleSubmit(onSubmit)}>
                {Constants[locale].Submit}
              </FlatButton>
            </form>
          </div>
        </div>
      ) : (
          <div className="content-container">
            <div className="success-container">
              <img src={SuccessImage} alt="Success" />
              <div className="success-title">{Constants[locale].SuccessTitle}</div>
              <div className="success-text">{Constants[locale].SuccessText}</div>
            </div>
          </div>
        )}
      <div className="footer-div">
        <div className="partner-heading ">
          <h3>{Constants[locale].Partners}</h3>
        </div>
        <div className="footer-partners">
          <div className="partner-div">
            <img src={HindustanPetroleumImage} alt="Hindustan Petroleum Logo" />
            <p>{Constants[locale].HindustanPetroleum}</p>
          </div>
          <div className="partner-div">
            <img src={IndianOil} alt="Indian Oil Logo" />
            <p>{Constants[locale].IndianOil}</p>
          </div>
          <div className="partner-div">
            <img src={ReliancePetroleum} alt="Reliance Petroleum Logo" />
            <p>{Constants[locale].ReliancePetroleum}</p>
          </div>
          <div className="partner-div">
            <img src={BharatPetroleumImage} alt="Bharat Petroleum Logo" />
            <p>{Constants[locale].BharatPetroleum}</p>
          </div>
          <div className="partner-div">
            <img src={EssarImage} alt="Essar Logo" />
            <p>{Constants[locale].Essar}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default FuelRegistration;
